import { render, staticRenderFns } from "./AvailableVariantsCard.vue?vue&type=template&id=4faac87a&scoped=true"
import script from "./AvailableVariantsCard.vue?vue&type=script&lang=js"
export * from "./AvailableVariantsCard.vue?vue&type=script&lang=js"
import style0 from "./AvailableVariantsCard.vue?vue&type=style&index=0&id=4faac87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faac87a",
  null
  
)

export default component.exports